module.exports = __webpack_public_path__ + "img/close-icon.30c465d2.svg";